import { mdiDomain } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/components/administration"
import type { OrgaViewFrameContext } from "../../../../context"

export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "properties",
  title: "Liegenschaften",
  tooltip: "Liegenschaften mit Adressen, Wohneinheiten und zugehörigen Ansprechpartnern pflegen.",
  icon: mdiDomain,
  routeSegment: "properties",
  getPages: (context) => [
    {
      id: "properties",
      title: "Liegenschaften",
      path: "",
    },
  ],
}
